import React from 'react';
import { Outlet, Route, Routes } from 'react-router';
import App from 'views/App';
import Resumo from 'views/Resumo';
import Configurações from 'views/Configurações';
import User from 'views/User';
import Inventario from 'views/Inventario';
import Movimentacoes from 'views/Movimentacoes';

const RoutesTree = () => (
  <Routes>
    <Route path="" element={<App />} />
    <Route path="Resumo" element={<Resumo />} />
    <Route path="Configuracoes" element={<Configurações />} />
    <Route path="User" element={<User />} />
    <Route path="Inventario" element={<Inventario />} />
    <Route path="Movimentacoes" element={<Movimentacoes />} />
  </Routes>
);

export default RoutesTree;
